// Path: src\Components\Rewards\Rewards.jsx
import React, { useState, useEffect, useTransition } from 'react'
import BaseHome from '../Home/BaseHome'
import TabWithBottomBorder from '../Common/TabWithBottomBorder';
import TabPanelSolid, { TabPanel } from '../Common/TabPanelSolid';
import ReedemPopup from "../Rewards/RewardStore/RedeemPopup";
import ReedemCouponPopup from "../Rewards/RewardStore/ReedemCouponPopup"
import RewardStore from './RewardStore/RewardStoreList';
import Packs from './Packs';
import Bundle from './Bundle';
import Avatars from './Avatars';
import MyRewards from './RewardStore/MyRewards';
import { useProfileDataContext } from '../ProfileContext/ProfileContext';
import BuyCoinPopup from "../Rewards/BuyPacks/BuyCoinPopup";
import { Link, useLocation } from "react-router-dom";
import { t } from 'i18next';

const Rewards = () => {
  const tabs = [t("rewards-store.reward"), t('rewards-store.coin_store')]
  const coinsTab = [t("rewards-store.packs"), t("rewards-store.bundle"), t("rewards-store.avatar")]
  // const rewardsTab = [t("reward"), t("my_reward")]
  const [rewardsTab, setRewardTab] = useState([]);
  const [isReedemPopup, setIsReedemPopup] = useState(false);
  const [isReedemCouponPopup, setReedemCouponPopup] = useState(false);
  const [activeTab, setActiveTab] = useState(0)
  const [value, setValue] = useState(0);
  const [isReward, setIsReward] = useState(false);
  const [reedemItem, setReedemItem] = useState({});
  const [myReedemItem, setMyReedemItem] = useState({});
  const { fetchAccountProfile } = useProfileDataContext();
  const [isBuyPopup, setIsBuyPopup] = useState(false);
  const [isBundle, setIsBundle] = useState(false);
  const param = useLocation();
  
  const getTabContent = () => {
    // switch (tabs) {
    //   case 0:
    //     return <div className="mytab-content"></div>;
    //   case 1:
    //     return <div className="mytab-content"></div>;

    //   default:
    //     return null;
    // }
  };

  useEffect(() => {
    setRewardTab( [t("rewards-store.reward"), t("rewards-store.title_my_reward")])
    if (param?.state) {
      setActiveTab(1)
    }
    
  }, [])

  const getTabs = (val, index, activeTab) => {
    return (
      <TabPanel className="rewards-body" value={val} index={index}>
        {/* <LeaderboardBox style={style} style1={style1} /> */}
        <div className='packs-wrapper scroll-none'>

          {activeTab === 0 ? (
            <>
              {/* Rewards */}
              {index === 0 ? (
                <RewardStore isReedemPopup={isReedemPopup} setIsReedemPopup={setIsReedemPopup} reedemItem={reedemItem} setReedemItem={setReedemItem} isReward={isReward} setIsReward={setIsReward} />
              ) : index === 1 ? (
                <MyRewards setReedemCouponPopup={setReedemCouponPopup} setMyReedemItem={setMyReedemItem} />
              ) : null}


            </>
          ) : (
            <>
              {/* Coin Store */}
              {
                index == 0 ?
                  <>
                    <Packs isReedemPopup={isBuyPopup} setIsReedemPopup={setIsBuyPopup} reedemItem={reedemItem} setReedemItem={setReedemItem} isReward={isReward} setIsReward={setIsReward} setIsBundle={setIsBundle} />
                  </>
                  : index == 1 ?
                    <>
                      <Bundle isReedemPopup={isBuyPopup} setIsReedemPopup={setIsBuyPopup} reedemItem={reedemItem} setReedemItem={setReedemItem} isReward={isReward} setIsReward={setIsReward} setIsBundle={setIsBundle} />
                    </>
                    :
                    <>
                      <Avatars isReedemPopup={isReedemPopup} setIsReedemPopup={setIsReedemPopup} reedemItem={reedemItem} setReedemItem={setReedemItem} isReward={isReward} setIsReward={setIsReward} />
                    </>
              }
            </>
          )}
        </div>
      </TabPanel>
    )
  }


  const handleReedeemed = () => {
    fetchAccountProfile()
    setValue(1)
  }

  const handleBuyCoin = () => {
    alert("here");
  }

  return (
    <BaseHome isFooter={true} isReward={true}>
    
      <TabWithBottomBorder newDesign={true} getTabContent={getTabContent} tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} setValue={setValue} />
      <TabPanelSolid tabs={activeTab == 0 ? rewardsTab : coinsTab} value={value} setValue={setValue} activeTab={activeTab} getTabs={getTabs} />
      {isReedemPopup && (
        <ReedemPopup
          isOpen={isReedemPopup}
          title={reedemItem?.name}
          onClose={() => setIsReedemPopup(false)}
          reedemItem={reedemItem}
          handleReedeemed={handleReedeemed}
          isReward={isReward}
          setIsReward={setIsReward}
        />
      )}
      {isBuyPopup && (
        <BuyCoinPopup
          isOpen={isBuyPopup}
          title={reedemItem?.name}
          onClose={() => setIsBuyPopup(false)}
          reedemItem={reedemItem}
          handleReedeemed={handleBuyCoin}
          isReward={isReward}
          setIsReward={setIsReward}
          isBundle={isBundle}
        />
      )}
      {isReedemCouponPopup && (
        <ReedemCouponPopup
          isOpen={isReedemCouponPopup}
          onClose={() => setReedemCouponPopup(false)}
          myReedemItem={myReedemItem}
        />
      )}
    </BaseHome>

  )
}

export default Rewards